export default "__VITE_ASSET__BUHhzCLW__"